import { IBrickInstanceTargetingAction } from '../../../../../utility/IBrickInstanceTargetingAction';

export class UserStatusAlternativeDeviceAddressChangedWithoutApplying implements IBrickInstanceTargetingAction {
   public static readonly type = '[UserStatusBehaviour] user status alternative device address changed without applying';

   constructor(public brickInstanceId: string, public deviceAddress: string) {}
}

export class ApplyAlternativeDeviceAddress implements IBrickInstanceTargetingAction {
   public static readonly type = '[UserStatusBehaviour] apply alternative device address';

   constructor(public brickInstanceId: string) {}
}

export class ResetAlternativeDeviceAddress implements IBrickInstanceTargetingAction {
   public static readonly type = '[UserStatusBehaviour] reset alternative device address';

   constructor(public brickInstanceId: string) {}
}
